import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	feedback: {
		id: 'spa-apps-jsw-list.page-header.feedback-button.feedback',
		defaultMessage: 'Give feedback',
		description: 'Button that opens the feedback dialog.',
	},
	tooltip: {
		id: 'spa-apps-jsw-list.page-header.feedback-button.tooltip',
		defaultMessage: 'This is for internal feedback',
		description: 'Tooltip of the feedback button.',
	},
});
